module.exports = __webpack_public_path__ + "img/Pelletlager-Reinigung.3e5b25e.webp";